import React from 'react'
import { oneOf, string } from 'prop-types'
import Typography from '../Typography/Typography'

const SectionTitle = ({ title, align = 'center', color = '#0c2846' }) => (
  <div className="section-title">
    <Typography component="h2" variant="headline" fontWeight="bold">
      {title}
    </Typography>
    <style jsx>
      {`
        .section-title {
          :global(h2) {
            color: ${color};
            text-align: ${align};
            margin: 0 0 24px !important;
            @media screen and (min-width: 768px) {
              font-size: 24px !important;
            }
          }
        }
      `}
    </style>
  </div>
)

SectionTitle.propTypes = {
  align: oneOf(['center', 'right', 'left']),
  color: string,
  title: string,
}

export default SectionTitle
